/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TenantThemeColor } from './TenantThemeColor';
import {
    TenantThemeColorFromJSON,
    TenantThemeColorFromJSONTyped,
    TenantThemeColorToJSON,
} from './TenantThemeColor';

/**
 * 
 * @export
 * @interface TenantThemeColors
 */
export interface TenantThemeColors {
    /**
     * 
     * @type {TenantThemeColor}
     * @memberof TenantThemeColors
     */
    primary?: TenantThemeColor;
    /**
     * 
     * @type {TenantThemeColor}
     * @memberof TenantThemeColors
     */
    secondary?: TenantThemeColor;
    /**
     * 
     * @type {TenantThemeColor}
     * @memberof TenantThemeColors
     */
    tertiary?: TenantThemeColor;
}

/**
 * Check if a given object implements the TenantThemeColors interface.
 */
export function instanceOfTenantThemeColors(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantThemeColorsFromJSON(json: any): TenantThemeColors {
    return TenantThemeColorsFromJSONTyped(json, false);
}

export function TenantThemeColorsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantThemeColors {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'primary': !exists(json, 'primary') ? undefined : TenantThemeColorFromJSON(json['primary']),
        'secondary': !exists(json, 'secondary') ? undefined : TenantThemeColorFromJSON(json['secondary']),
        'tertiary': !exists(json, 'tertiary') ? undefined : TenantThemeColorFromJSON(json['tertiary']),
    };
}

export function TenantThemeColorsToJSON(value?: TenantThemeColors | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'primary': TenantThemeColorToJSON(value.primary),
        'secondary': TenantThemeColorToJSON(value.secondary),
        'tertiary': TenantThemeColorToJSON(value.tertiary),
    };
}

